<template>


    <div class="col-12">
        <div class="row" v-if="!pedidosData.length">
            <div class="col-12 text-center mb-4" style="font-size: 1.2rem;">
                No hay pedidos que valorar
            </div>
        </div>

        <encuesta-variedad-component v-else v-for="pedido in pedidosData" :key="keyFromPedido(pedido)" :pedido="pedido" @voted="voted"></encuesta-variedad-component>
    </div>



</template>

<script>
    import EncuestaVariedadComponent from "./EncuestaVariedadComponent";

    export default {
        name: "EncuestaVariedadesComponent",
        props: ['pedidos'],
        components: {
            EncuestaVariedadComponent
        },
        data: function () {
            return{
                pedidosData:  _.cloneDeep(this.pedidos),
            }
        },
        methods: {
            voted(pedido) {
                let index = this.pedidosData.findIndex(p => p.id === pedido.id && (p.variety ? 1 : 0) === (pedido.variety ? 1 : 0));
                this.pedidosData.splice(index, 1);
            },
            keyFromPedido(pedido) {
                return (pedido.variety ? 'custom' : 'disponible') + pedido.id
            }
        }
    }
</script>
